import * as Sentry from '@sentry/react';
import axios from './axios';
import { setSession } from './jwt';

// Global logout flag to prevent multiple logout calls in quick succession
let isLoggingOut = false;

interface LogoutOptions {
    unregisterAnalytics?: () => void;
    reload?: boolean;
}

export const performLogout = async (options: LogoutOptions = {}): Promise<void> => {
    const { unregisterAnalytics, reload = false } = options;

    if (isLoggingOut) {
        return;
    }
    isLoggingOut = true;

    try {
        await axios.post('/oauth/logout');
    } catch (error) {
        console.error('Logout API call failed:', error);
    }

    setSession(null);

    Sentry.setUser(null);

    if (unregisterAnalytics) {
        unregisterAnalytics();
    }

    if (reload) {
        alert('Your session has expired. Please log in again.');
        window.location.reload();
    }
};
